import dayjs from 'dayjs';

// Constants
import { MONTHS } from '@shared/constants';

/**
 * Check if engagement duration is valid to display
 * @param years - Number of years
 * @param months - Number of months
 * @returns boolean
 */
export const shouldShowEngagement = (years: number, months: number): boolean =>
  years > 0 || months > 0;

/**
 * Calculate engagement duration from onboarded date
 * @param onboardedAt - Onboarding date string
 * @param targetYear - Target year to calculate up to
 * @returns Object containing years and months
 */
export const calculateEngagement = (
  onboardedAt?: string,
  targetYear?: number,
): { years: number; months: number } => {
  if (!onboardedAt) return { years: 0, months: 0 };

  const start = dayjs(onboardedAt);
  const end = targetYear ? dayjs(new Date(targetYear, 11, 31)) : dayjs();

  // Calculate years and months
  const years = end.diff(start, 'year');
  const monthsTotal = end.diff(start, 'month');
  const months = monthsTotal % 12;

  return { years, months };
};
/**
 * Check if the year is valid to display the anniversary badge (0-99).
 * Also checks if the year is a multiple of 5 (5, 10, 15...).
 * @param years - Number of years
 * @returns boolean
 */
export const shouldShowAnniversaryBadge = (years?: number): years is number =>
  years !== undefined && years > 0 && years < 100 && years % 5 === 0;

/**
 * Formats ISO date string to 'MMM DD, YYYY' (e.g. 'Jan 14, 2017') using UTC.
 */
export const formatOnboardingDate = (dateString?: string): string => {
  if (!dateString) return '';

  const date = new Date(dateString);

  // Return original string if date is invalid
  if (isNaN(date.getTime())) return dateString;

  // Use UTC to avoid timezone-related date shifts
  const month = MONTHS[date.getUTCMonth()];
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  return `${month} ${day}, ${year}`;
};
